import { CircularProgress, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useGetMessageCollectionDetail } from "../../App/Queries/MessageQueries";
import { IMessageHistory, IMessagePerformanceDto } from "../../App/Typings/MessageText";
import { MessageHistoryListItem } from "../../MessageComponents/MessageDialog/Components/MessageHistory";

export default function IndividualTextCollectionDisplay({
  selectedCollection,
}: {
  selectedCollection: IMessagePerformanceDto | undefined;
}) {
  const [previewTemplateView, setPreviewTemplateView] = useState<IMessageHistory | null>(null);
  const { data, isLoading, isError } = useGetMessageCollectionDetail(
    selectedCollection?.messageCollectionId ?? "",
  );

  useEffect(() => {
    if (data) {
      setPreviewTemplateView({
        messageId: "",
        messageTrackingId: "",
        scheduledTimeEastern: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss"),
        messageDisplay: data.message,
        messageState: "DELIVERED",
        userName: "",
        created: dayjs().utc(),
        candidateCount: 1,
        type: "DirectTextMessage",
        scheduledUtcTime: dayjs().utc(),
        dateSort: dayjs().utc(),
        messageType: "DirectTextMessage",
        isScheduled: false,
        groupName: "",
        errorMessage: "",
        hasBeenRead: false,
        userHasReplyNotification: false,
      });
    }
  }, [data]);
  return isLoading ? (
    <Stack alignItems="center" justifyContent="center">
      <CircularProgress size={20} color="inherit" />
    </Stack>
  ) : isError || !previewTemplateView ? (
    <Typography variant="body1">Error loading message</Typography>
  ) : (
    <MessageHistoryListItem msg={previewTemplateView} showDate={false} />
  );
}
